"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.passwordReset = void 0;
const helpers_1 = require("../../helpers");
const agents_1 = require("../agents");
const sendEmail_1 = require("../sendEmail");
const passwordReset = async (supabase, email, agent_id, redirect_to) => {
    const { data, error } = await supabase
        .rpc("check_email_provider", {
        email_address: email,
    })
        .single();
    if (!data || error) {
        // no account found.  Return success anyway.
        return {
            success: true,
            message: "Password reset email sent",
        };
    }
    const agent = await (0, agents_1.getAgentById)(supabase, agent_id);
    const { data: linkData, error: linkError } = await supabase.auth.admin.generateLink({
        type: "recovery",
        email: email,
        options: {
            redirectTo: redirect_to,
        },
    });
    if (linkError) {
        // no account found.  Return success anyway.
        return {
            success: true,
            message: "Password reset email sent",
        };
    }
    const email_obj = {
        agent: {
            id: agent.id,
            logo: agent.logo,
            name: agent.name,
            email: agent.email,
            phone: agent.phone,
        },
        redirect_url: linkData?.properties?.action_link,
    };
    // email support with request details
    const password_reset_email = {
        language_code: "en",
        template_id: helpers_1.PASSWORD_RESET,
        data: email_obj,
        email_address: email,
    };
    const email_response = await (0, sendEmail_1.sendEmail)(password_reset_email);
    console.log("EMAIL RESPONSE", email_response);
    return {
        success: true,
        message: "Password reset email sent",
    };
};
exports.passwordReset = passwordReset;
